import React from 'react';
import { WidgetProps } from '@/lib/widgets/types';
import { StatsWidget } from './StatsWidget';
import { useGpsDeviceStats } from '@/hooks/use-gps-device-stats';
import { useGpsTripsStats } from '@/hooks/use-gps-trips-stats';
import { useGpsAlertStats } from '@/hooks/use-gps-alert-stats';
import { useAuth } from '@/hooks/use-auth';

export function TrackingOnlineVehiclesWidget(props: WidgetProps) {
  const { user } = useAuth();
  const companyId = user?.user_metadata?.company_id;
  const { data: stats, isLoading } = useGpsDeviceStats(companyId);

  return (
    <StatsWidget
      {...props}
      title="Veículos Online"
      value={isLoading ? '...' : `${stats?.online || 0}/${stats?.total || 0}`}
      description="Transmitindo posição"
      icon="Navigation"
    />
  );
}

export function TrackingTripsWidget(props: WidgetProps) {
  const { user } = useAuth();
  const companyId = user?.user_metadata?.company_id;
  const { data: stats, isLoading } = useGpsTripsStats(companyId);

  return (
    <StatsWidget
      {...props}
      title="Viagens Hoje"
      value={isLoading ? '...' : String(stats?.today || 0)}
      description="Viagens realizadas"
      icon="Route"
      trend={stats ? { value: stats.percentChange, label: "vs ontem" } : undefined}
    />
  );
}

export function TrackingGeofenceAlertsWidget(props: WidgetProps) {
  const { user } = useAuth();
  const companyId = user?.user_metadata?.company_id;
  const { data: stats, isLoading } = useGpsAlertStats(companyId);

  return (
    <StatsWidget
      {...props}
      title="Alertas de Geocerca"
      value={isLoading ? '...' : String(stats?.byType.geofence || 0)}
      description="Hoje"
      icon="MapPin"
    />
  );
}

export function TrackingSpeedAlertsWidget(props: WidgetProps) {
  const { user } = useAuth();
  const companyId = user?.user_metadata?.company_id;
  const { data: stats, isLoading } = useGpsAlertStats(companyId);

  return (
    <StatsWidget
      {...props}
      title="Alertas de Velocidade"
      value={isLoading ? '...' : String(stats?.byType.speed || 0)}
      description="Esta semana"
      icon="Gauge"
      trend={{ value: stats?.byType.speed ? -15 : 0, label: "redução" }}
    />
  );
}
